/* eslint-disable prefer-arrow-callback */
import { type MutableRefObject, useEffect, useRef } from "react";

import { useIsMutating } from "@tanstack/react-query";

import {
  CREATE_SOIL_SIGHT_PROJECT,
  CREATE_SOIL_SIGHT_SCENARIO,
  DELETE_SOIL_SIGHT_SCENARIO,
  REPLACE_SOIL_SIGHT_CROP_YEARS,
  UPDATE_SOIL_SIGHT_PROJECT_SETTINGS,
  UPDATE_SOIL_SIGHT_SCENARIO,
} from "consts";

/** Mirror mutating count into a ref for `waitUntilIdle` without re-rendering consumers. */
const useIsMutatingCountRef = (count: number): MutableRefObject<number> => {
  const ref = useRef(count);
  useEffect(
    function mirrorMutatingCount() {
      ref.current = count;
    },
    [count]
  );
  return ref;
};

/** How many Soil Sight saves are in flight, as a value (re-renders) and as a ref (for waitUntilIdle). */
export const useIsSavingSoilSight = (): { isSavingCount: number; isSavingRef: MutableRefObject<number> } => {
  const isSavingCount =
    useIsMutating({ mutationKey: [CREATE_SOIL_SIGHT_PROJECT] }) +
    useIsMutating({ mutationKey: [UPDATE_SOIL_SIGHT_PROJECT_SETTINGS] }) +
    useIsMutating({ mutationKey: [CREATE_SOIL_SIGHT_SCENARIO] }) +
    useIsMutating({ mutationKey: [UPDATE_SOIL_SIGHT_SCENARIO] }) +
    useIsMutating({ mutationKey: [DELETE_SOIL_SIGHT_SCENARIO] }) +
    useIsMutating({ mutationKey: [REPLACE_SOIL_SIGHT_CROP_YEARS] });
  const isSavingRef = useIsMutatingCountRef(isSavingCount);
  return { isSavingCount, isSavingRef };
};
